<template>
<div>
  <div class="alert alert-warning" style="width:100%;max-width:666px;margin:0 auto;">
      There was a problem loading your information <span v-if="showReloadMessage">[{{showReloadMessage}}]</span>: <span @click="reloadData" class="reload-link">Click here to try again</span>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: ['show-reload-message'],
  mounted() {
  },
  methods:
        {
          reloadData() {
            location.reload();
          },
        },
  watch: {

  },
};
</script>

<style scoped>
    .reload-container {
        clear:both;
        width:100%;
        max-width:666px;
        margin:0 auto;
        background:#808080;
        color:white;
        padding:20px;
        border-radius: 5px;
    }
    .reload-link {
        font-weight: bold;
        cursor: pointer;
    }
</style>
